import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";
import { useEffect } from "react";

const PROMPT_LIBRARY_QUERY_KEY = "prompt-library";

const CACHE_TIME_IN_MS = 1000 * 60 * 10;

export const useGetPromptLibrary = ({ enabled = true } = {}) => {
  const chatApi = getChatApiClient();

  const query = useQuery({
    queryKey: [PROMPT_LIBRARY_QUERY_KEY],
    enabled,
    queryFn: async ({ signal }) => {
      const response = await chatApi.chatControllerGetPromptLibrary({
        signal,
      } as RequestInit);
      return response;
    },
    retry: 2,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  const { error } = query;

  useEffect(() => {
    if (error) {
      console.error("Failed to load prompt library.", error);
    }
  }, [error]);

  return extractQueryState(query);
};
